import React from 'react';
import { PiSignOut, PiQrCode, PiTicket, PiNotePencil } from "react-icons/pi";
import { Link } from "react-router-dom";

function UserButtons() {
  const roll = parseInt(localStorage.getItem('userRoll'));

  function clearLocalStorage() {
    localStorage.clear();
    window.location.href = '/';
  }

  return (
    <div className="flex flex-col items-center justify-center w-full px-4 py-8 gap-8" data-testid="user-buttons-container">
      {/* Mostrar botones de QR y Crear Ticket solo si el roll no es 2 o 3 */}
      {roll === 2 && (
        <>
          <div className="w-full max-w-md" data-testid="user-buttons-qr-container">
            <Link to="/qr-generator?autoGenerate=true" className="w-full px-6 py-4 text-white text-lg font-semibold rounded-lg shadow-md flex items-center justify-between relative overflow-hidden group" data-testid="user-buttons-qr-link">
              <div className="absolute inset-0 bg-gradient-to-r from-amber-300 to-amber-700 transition-transform duration-700 ease-in-out"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-amber-300 to-amber-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
              <span className="z-10 flex items-center" data-testid="user-buttons-qr-text">
                <PiQrCode className="text-2xl mr-3" />
                Generar Código QR
              </span>
              <svg className="z-10 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </Link>
          </div>

          <div className="w-full max-w-md" data-testid="user-buttons-create-ticket-container">
            <Link to="/CreateTicket" className="w-full px-6 py-4 text-white text-lg font-semibold rounded-lg shadow-md flex items-center justify-between relative overflow-hidden group" data-testid="user-buttons-create-ticket-link">
              <div className="absolute inset-0 bg-gradient-to-r from-purple-300 to-purple-700 transition-transform duration-700 ease-in-out"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-purple-300 to-purple-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
              <span className="z-10 flex items-center" data-testid="user-buttons-create-ticket-text">
                <PiNotePencil className="text-2xl mr-3" />
                Crear Ticket
              </span>
              <svg className="z-10 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </Link>
          </div>
        </>
      )}

      <div className="w-full max-w-md" data-testid="user-buttons-ticket-container">
        <Link to="/TicketsTable" className="w-full px-6 py-4 text-white text-lg font-semibold rounded-lg shadow-md flex items-center justify-between relative overflow-hidden group" data-testid="user-buttons-ticket-link">
          <div className="absolute inset-0 bg-gradient-to-r from-purple-300 to-purple-700 transition-transform duration-700 ease-in-out"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-purple-300 to-purple-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
          <span className="z-10 flex items-center" data-testid="user-buttons-ticket-text">
            <PiTicket className="text-2xl mr-3" />
            Mis Tickets
          </span>
          <svg className="z-10 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </Link>
      </div>

      <div className="w-full max-w-md" data-testid="user-buttons-logout-container">
        <button 
          onClick={clearLocalStorage}
          className="w-full px-6 py-4 text-white text-lg font-semibold rounded-lg shadow-md flex items-center justify-between relative overflow-hidden group"
          data-testid="user-buttons-logout-button"
        >
          <div className="absolute inset-0 bg-gradient-to-t from-red-400 to-red-800 transition-transform duration-700 ease-in-out"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-red-400 to-red-800 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
          <span className="z-10 flex items-center" data-testid="user-buttons-logout-text">
            <PiSignOut className="text-2xl mr-3" />
            Cerrar Sesión
          </span>
          <svg className="z-10 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export { UserButtons };
